import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import CustomMonthYearIndividualDatePicker from '../../../Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker';
import BiMonthlyPeriodModal from '../../../ClientDetails/Modals/BiMonthlyPeriodModal';

const formatDateToYearMonth = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    return `${year}/${month}`;
};

const WithholdingModalHeader = ({
    t,
    direction,
    isRange,
    isBiMonthly,
    date,
    startDate,
    endDate,
    biStartDate,
    biEndDate,
    showBiMonth,
    setShowBiMonth,
    handleDateChangeNew,
    handleStartDateChangeNew,
    handleEndDateChangeNew,
    handleBiMonthDate,
    handleDownloadComparativeAdvance,
    onClose,
    partners,
    internalSelectedPartner,
    handlePartnerChange,
    isSubordinateClient
}) => {
    return (
        <div className="wht-modal-header">
            <div className="wht-modal-header__top-row">
                <h2 className="wht-modal-header__title">{t('IncomeTaxAdvanceReport')}</h2>

                <button className="wht-modal-header__comparative-btn" onClick={handleDownloadComparativeAdvance}>
                    {t('ComparativeAdvancesReport')}
                </button>

                <div className="wht-modal-header__date-section">
                    {isRange ? (
                        <div className="wht-modal-header__range-pickers">
                            <CustomMonthYearIndividualDatePicker
                                year={startDate}
                                month={startDate}
                                onYearChange={(v) => handleStartDateChangeNew(v, 'year')}
                                onMonthChange={(v) => handleStartDateChangeNew(v, 'month')}
                                labelYear={t("StartYear")}
                                labelMonth={t("StartMonth")}
                                height="36px"
                                widthOuter="200px"
                                widthInner="90px"
                                flip={false}
                            />
                            <div className="wht-modal-header__date-divider" />
                            <CustomMonthYearIndividualDatePicker
                                year={endDate}
                                month={endDate}
                                onYearChange={(v) => handleEndDateChangeNew(v, 'year')}
                                onMonthChange={(v) => handleEndDateChangeNew(v, 'month')}
                                labelYear={t("EndYear")}
                                labelMonth={t("EndMonth")}
                                height="36px"
                                widthOuter="200px"
                                widthInner="90px"
                                flip={false}
                            />
                        </div>
                    ) : isBiMonthly ? (
                        <>
                            <div className="wht-modal-header__bimonth-display" onClick={() => setShowBiMonth(true)}>
                                <span>{formatDateToYearMonth(biStartDate.toISOString())}</span>
                                <span> - </span>
                                <span>{formatDateToYearMonth(biEndDate.toISOString())}</span>
                            </div>
                            <BiMonthlyPeriodModal
                                visible={showBiMonth}
                                onClose={() => setShowBiMonth(false)}
                                date={biStartDate}
                                t={t}
                                onDateChange={(s, e) => handleBiMonthDate(s, e)}
                            />
                        </>
                    ) : (
                        <CustomMonthYearIndividualDatePicker
                            year={date}
                            month={date}
                            onYearChange={(v) => handleDateChangeNew(v, 'year')}
                            onMonthChange={(v) => handleDateChangeNew(v, 'month')}
                            labelYear={t("Year")}
                            labelMonth={t("Month")}
                            height="36px"
                            widthOuter="200px"
                            widthInner="90px"
                            flip={false}
                        />
                    )}
                </div>

                {partners?.length > 0 && (
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel sx={{ fontSize: '12px' }}>{t('Partner')}</InputLabel>
                        <Select
                            value={internalSelectedPartner || ''}
                            onChange={(e) => handlePartnerChange(e.target.value)}
                            label={t('Partner')}
                            sx={{ borderRadius: '8px', fontSize: '12px' }}
                            disabled={isSubordinateClient}
                        >
                            {partners.map((p) => (
                                <MenuItem key={p.id} value={p.id}>
                                    {p.name} ({p.equity}%)
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                <button className="wht-modal-header__close-btn" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                        <path d="M15.2501 4.75831C14.9251 4.43331 14.4001 4.43331 14.0751 4.75831L10.0001 8.82498L5.9251 4.74998C5.6001 4.42498 5.0751 4.42498 4.7501 4.74998C4.4251 5.07498 4.4251 5.59998 4.7501 5.92498L8.8251 9.99998L4.7501 14.075C4.4251 14.4 4.4251 14.925 4.7501 15.25C5.0751 15.575 5.6001 15.575 5.9251 15.25L10.0001 11.175L14.0751 15.25C14.4001 15.575 14.9251 15.575 15.2501 15.25C15.5751 14.925 15.5751 14.4 15.2501 14.075L11.1751 9.99998L15.2501 5.92498C15.5668 5.60831 15.5668 5.07498 15.2501 4.75831Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default WithholdingModalHeader;
